import React, { useState } from 'react'
import styled from 'styled-components'
import { updateEstudiante } from '../../network/lib/admin'

function ModalEditarEstudiante({data, close}) {

    const [newData, setNewData] = useState({
        apellido: data.lastName,
        nombre: data.firstName,
        legajo: data.legajo,
        id: data.id
    })


    const editarEstudiante = (data) => {
        updateEstudiante(data).then((res)=>{
            console.log(res)
            if(res.data.errno){
                alert('Está ingresando un legajo que ya existe en la base de datos para otro estudiante.')
            }
            close()
        }).catch((err)=>{
            console.log(err)
        })
    }

    return (
        <Container>
            <Modal>
                <Alerta>
                    <Titulo>Editar estudiante</Titulo>
                </Alerta>
                <Input value={newData.apellido} type="text" onChange={(e)=> setNewData({...newData, apellido: e.target.value})}/>
                <Input value={newData.nombre} type="text" onChange={(e)=> setNewData({...newData, nombre: e.target.value})}/>
                <Input value={newData.legajo} type="text" onChange={(e)=> setNewData({...newData, legajo: e.target.value})}/>
                <Botones>
                    <Cerrar onClick={close}>Cancelar</Cerrar>
                    <Confirmar onClick={() => editarEstudiante(newData)}>Confirmar</Confirmar>
                </Botones>
            </Modal>
        </Container>
    )
}

const Container = styled.div`
    display: block;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 9999;
    width: 100%;
    height: 100%;
    padding-top: 200px;
    background-color: black;
    background-color: rgba(0, 0, 0, 0.4);
    -webkit-transition: 0.5s;
    overflow: auto;
    transition: all 0.3s linear;
`

const Input = styled.input`
    outline: none;
    border: 1px solid #F8F9FA;
    color: #989898;
    padding: 10px 20px;
    border-radius: 10px;
    margin-bottom: 10px;
    width: 80%;
    margin-left: auto;
    margin-right: auto;
    &::placeholder{
        font-weight: 600;
    }
`

const Modal = styled.div`
    padding: 20px;
    background-color: #fff;
    border-radius: 20px;
    max-width: 500px;
    height: auto;
    display: flex;
    flex-direction: column;
    margin-left: auto;
    margin-right: auto;
    @media(max-width: 768px){
        margin: 10px;
        max-width: 250px;
        margin-left: auto;
        margin-right: auto;
    }
`

const Botones = styled.div`
    display: flex;
    gap: 20px;
    margin-top: 30px;
    @media(max-width: 768px){
        margin-top: 20px;
    }
`

const Cerrar = styled.button`
    cursor: pointer;
    border: none;
    padding: 15px 38px;
    margin-left: auto;
    width: 30%;
    background-color: #C4C4C4;
    border-radius: 14px;
    font-weight: 600;
    color: #fff;
    @media(max-width: 768px){
        padding: 8px 20px;
        border-radius: 8px;
        font-size: 12px;
        line-height: 13px;
    }
`

const Confirmar = styled.button`
    cursor: pointer;
    border: none;
    padding: 15px 38px;
    margin-right: auto;
    width: 30%;
    background-color: #7778fe;
    border-radius: 14px;
    font-weight: 600;
    color: #fff;
    @media(max-width: 768px){
        padding: 8px 20px;
        border-radius: 8px;
        font-size: 12px;
        line-height: 13px;
    }
`

const Alerta = styled.div`
    margin-left: auto;
    margin-right: auto;
    text-align: center;
`

const Titulo = styled.div`
    font-weight: bold;
    font-size: 24px;
    color: #525252;
    margin-bottom: 30px;
    @media(max-width: 768px){
        font-size: 18px;
    }
`

export default ModalEditarEstudiante